'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const LiveUsersChartInner = dynamic(() => import('./LiveUsersChartInner'), { ssr: false });

export default function LiveUsersChart() {
  return (
    <div className="card-surface p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Real-Time Active Users</h2>
          <p className="text-sm text-muted-foreground">Concurrent sessions — last 24 hours</p>
        </div>
        <div className="flex items-center gap-2 bg-positive/10 rounded-lg px-2.5 py-1.5">
          <span className="w-2 h-2 rounded-full bg-positive pulse-live" />
          <span className="text-xs font-semibold text-positive">3,847 live</span>
        </div>
      </div>
      <LiveUsersChartInner />
    </div>
  );
}